// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LRh8","footer":"styles_footer__2PVKb"};